<template>
  	<div class="login article-login" @click="goLogin">
        <a href="javascript:void(0)" data-role="login-btn" class="login-sohu">登录</a>
    </div>
</template>

<script>
import { importLogin } from '@/utils/login'

export default {
	name: "un-login-btn",
	data() {
        return {

        }
    },
    mounted() {
        // 监听登录成功
        window.EVENT_BUS.$on('loginSuccess',this.handleImportLogin)
    },
    methods: {
        goLogin() {
            window?.sohuSpm?.sendAction({
                acode: 8080
            });
            this.handleImportLogin(true)
        },
        // 动态引入pc-login
        handleImportLogin(showLoginModal=false) {
            importLogin().then((res)=>{
                const LoginBtn = res.loginBtnIndex
                new LoginBtn({
                    el: "#head-login",
                    mark: "article",
                    type: "other"
                });
                if(showLoginModal) {
                    const loginIndex = res.loginIndex
                    loginIndex.login()
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.article-login {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    &:hover {
        cursor: pointer;
    }
    .login-sohu {
        width: 52px;
        height: 28px;
        background: rgba(255,255,255,0.2);
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF !important;
        line-height: 28px;
        text-align: center;
        transition: all 0.3s ease-in-out;
        &:hover{
            background-color: hsla(0,0%,100%,.4);
        }
    }
}
</style>
